<template>
  <oie-my-pages-template v-element-loader="{endpoint: 'shoppinglist/loadAll'}" :title="t('shoppingListsTitle')" :text="t('shoppingListsSubTitle')">
    <oie-action-wrapper>
      <template #left>
        <oie-base-input :value="filter" :placeholder="tStatic('searchShoppingListPlaceholder')" @input="setFilter">
          <template #iconPrepend>
            <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
          </template>
        </oie-base-input>
      </template>
      <oie-add-option-slide-in
        :label-text="tStatic('newShoppingListButtonLabel')"
        :title="tStatic('addNewShoppingListHeader')"
        :text="tStatic('addNewShoppingListText')"
        @add-option="createNewShoppingList">
        <template #activator="{open}">
          <oie-base-action
            v-tooltip.top="tStatic('newShoppingListTooltip')"
            theme="flat"
            :only-icon-mobile="true"
            @click="open">
            <template #iconPrepend>
              <oie-base-icon icon="shopping-list" size="s"></oie-base-icon>
            </template>
            {{ tStatic('newShoppingListButtonLabel') }}
          </oie-base-action>
        </template>
      </oie-add-option-slide-in>
    </oie-action-wrapper>
    <div class="my-shopping-lists__content">
      <oie-shopping-lists-table :shopping-lists="filteredShoppingLists"></oie-shopping-lists-table>
    </div>
  </oie-my-pages-template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myPages from '@/mixins/my-pages'

export default {
  mixins: [myPages],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('myShoppingLists', ['shoppingLists', 'filter', 'filteredShoppingLists'])
  },
  mounted() {
    this.resetSelectedShoppingList()
    this.getShoppingLists()
  },
  methods: {
    ...mapActions('myShoppingLists', ['getShoppingLists', 'resetSelectedShoppingList', 'addNewShoppingList', 'selectShoppingList', 'setFilter']),
    ...mapActions('ui', ['setActiveSlideIn']),
    async createNewShoppingList(name) {
      const response = await this.addNewShoppingList(name)
      this.setActiveSlideIn(null)
      this.selectShoppingList(response.data.id)
      this.goToSubPage(this.navigationOptions.oieMyShoppingList)
    }
  }
}
</script>
